module.exports = "<div class=\"container-fluid\" id=\"error-page\">\n  <div class=\"content\">\n    <img alt=\"logo\" src=\"assets/img/logo_deo.png\" />\n    <h2>{{ errorMessage }}</h2>\n    <div [hidden]=\"errorCode != 404\">\n      <a routerLink=\"/dashboard\" class=\"nav-link\">Volver al Dashboard</a>\n    </div>\n    <div [hidden]=\"errorCode == 404\">\n      <a routerLink=\"/login\" class=\"nav-link\">Volver al Inicio</a>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/error-page/error-page.component.html
// module id = ./src/app/common/error-page/error-page.component.html
// module chunks = main